import { Text, Heading, Stack, Grid, GridItem } from "@chakra-ui/react";
import { FC, Fragment, ReactNode } from "react";
import { formatDate } from "../../../helpers/dateUtils";
import FieldOccurencesState from "./FieldOccurencesState";

interface ModalBodyOccurrenceManualProps {
  control: any;
}

const ModalBodyOccurrenceManual: FC<ModalBodyOccurrenceManualProps> = ({
  control,
}) => {
  const details: { label: string; value: ReactNode }[] = [
    {
      label: "Tipo de ocorrência:",
      value: (
        <Text whiteSpace="nowrap">
          {control._formValues.row?.type?.name || "-"}
        </Text>
      ),
    },
    {
      label: "Criado a:",
      value: (
        <Text whiteSpace="nowrap">
          {control._formValues.row?.createdAt
            ? formatDate(new Date(control._formValues.row?.createdAt))
            : "-"}
        </Text>
      ),
    },
    {
      label: "Estado da ocorrência:",
      value: (
        <FieldOccurencesState
          stateValue={
            control._formValues.row?.type.id === 1
              ? control._formValues.row?.isActive
              : null
          }
          additionalStyle={{ display: "inline-block" }}
        />
      ),
    },
    {
      label: "Nível:",
      value: (
        <Text whiteSpace="nowrap">
          {control._formValues.row?.level?.name || "-"}
        </Text>
      ),
    },
    {
      label: "Origem da ocorrência:",
      value: (
        <Text whiteSpace="nowrap">
          {control._formValues.row?.origin || "-"}
        </Text>
      ),
    },
    {
      label: "Província:",
      value: (
        <Text whiteSpace="nowrap">
          {control._formValues.row?.province?.name || "-"}
        </Text>
      ),
    },
    {
      label: "Município:",
      value: (
        <Text whiteSpace="nowrap">
          {control._formValues.row?.county?.name || "-"}
        </Text>
      ),
    },
    {
      label: "Detalhes sobre a ocorrência:",
      value: <Text>{control._formValues.row?.description || "-"}</Text>,
    },
  ];

  return (
    <Stack gap="8">
      <Stack gap="4">
        <Heading as="h4" fontSize="xl">
          Sobre a ocorrência
        </Heading>
        <Grid
          templateColumns={{ base: "1fr", md: "max-content 1fr" }}
          columnGap={{ base: 0, md: 6 }}
          rowGap={2}
        >
          {details.map(({ label, value }) => (
            <Fragment key={label}>
              <GridItem>
                <Text fontWeight="bold" whiteSpace="nowrap">
                  {label}
                </Text>
              </GridItem>
              <GridItem>{value}</GridItem>
            </Fragment>
          ))}
        </Grid>
      </Stack>
    </Stack>
  );
};

export default ModalBodyOccurrenceManual;
